"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckOpenState = useCheckOpenState;

var _react = require("react");

var _utils = require("../utils");

var isInputFocused = function isInputFocused(inputElement) {
  return inputElement && inputElement === (0, _utils.getActiveElement)();
};

function useCheckOpenState(resultsLength, shouldShowListOnNoResults, inputRef) {
  var listIsHiddenOnNoResults = !shouldShowListOnNoResults; // Results count in ref, cause `stateReducer` in useCombobox hook is async.
  // It's memozing all values inside and we are getting old results length.

  var resultsCount = (0, _react.useRef)(resultsLength);
  resultsCount.current = resultsLength; // isOpen is the current state from useCombobox.
  // It sets correct open state for the dropdown list and useCombobox.

  var getOpenStateValue = (0, _react.useCallback)(function (isOpen) {
    if (listIsHiddenOnNoResults && isOpen === true) {
      return resultsCount.current > 0;
    }

    return isOpen;
  }, [listIsHiddenOnNoResults]); // useCombobox stateReducer works synchronous, with asynchronously passed results it doesn't fire action.
  // This fixes the side effect and set correct open state for the list.

  var onResultsChanges = (0, _react.useCallback)(function (isOpen, callback) {
    if (listIsHiddenOnNoResults && resultsLength > 0 && getOpenStateValue(isOpen) === false && isInputFocused(inputRef.current)) {
      callback();
    }
  }, [inputRef, listIsHiddenOnNoResults, getOpenStateValue, resultsLength]);
  return {
    getOpenStateValue: getOpenStateValue,
    onResultsChanges: onResultsChanges
  };
}